import ptBrLocale from './pt_BR.json';
import enLocale from './en.json';

let isRegistered = false;

export function registerCrmLocales(i18n) {
  if (isRegistered || !i18n) return;

  if (typeof i18n.mergeLocaleMessage === 'function') {
    i18n.mergeLocaleMessage('pt_BR', ptBrLocale);
    i18n.mergeLocaleMessage('pt', ptBrLocale);
    i18n.mergeLocaleMessage('en', enLocale);
    isRegistered = true;
  } else if (i18n.global && typeof i18n.global.mergeLocaleMessage === 'function') {
    i18n.global.mergeLocaleMessage('pt_BR', ptBrLocale);
    i18n.global.mergeLocaleMessage('pt', ptBrLocale);
    i18n.global.mergeLocaleMessage('en', enLocale);
    isRegistered = true;
  }
}
